import clienteAxios from "../config/axios";

export async function getAllTemplatesProduccion() {
    return clienteAxios.get('/templateProduccion');
}

export async function addTemplateProduccion(template) {
    return clienteAxios.post('/templateProduccion', { template });
}

export async function updateTemplateProduccion(id, updates) {
    return clienteAxios.put(`/templateProduccion/${id}`, { updates });
}

export async function deleteTemplateProduccion(id) {
    return clienteAxios.delete(`/templateProduccion/${id}`);
}
